import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { styles } from '../../styles/form-styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CheckboxGroup from './CheckboxGroup';
import Switch from './Switch';

class MonitorsModal extends React.Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleSave = () => {
    this.props.updateDataMapContainer(this.props.dataMapContainer, this.props.checkboxes, this.props.onSiteChange);
    this.handleClose();
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.monitors}>
        <Button variant="outlined" onClick={this.handleClickOpen}>
          Select sites to monitor
        </Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
        <div className={classes.dialogTitle}>
          <DialogTitle id="form-dialog-title">
            Sites
          </DialogTitle>
          <Switch
            checked={this.props.allChecked}
            onChange={this.props.handleSelectAll}
            value="select all"
            label="Select all"
          />
          </div>
          <DialogContent>
            <CheckboxGroup checkboxes={this.props.checkboxes} toggleChecked={this.props.toggleChecked}/>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} variant="contained" color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSave} variant="contained" color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

MonitorsModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MonitorsModal);



// WEBPACK FOOTER //
// ./src/components/Settings/MonitorsModal.js